import { gql } from '@utils/gpl-dedup';
import { userFragment } from '@graphql/users/fragments';

export const login = gql`
  mutation login($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user {
        id
        ...user
      },
      token
    }
  }
  ${userFragment}
`;
